/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findPresences } from '../fn/agn-presence/find-presences';
import { FindPresences$Params } from '../fn/agn-presence/find-presences';
import { Presence } from '../models/presence';

@Injectable({ providedIn: 'root' })
export class AgnPresenceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findPresences()` */
  static readonly FindPresencesPath = '/api/agn-presences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPresences()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPresences$Response(params: FindPresences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Presence>>> {
    return findPresences(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPresences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPresences(params: FindPresences$Params, context?: HttpContext): Observable<Array<Presence>> {
    return this.findPresences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Presence>>): Array<Presence> => r.body)
    );
  }

}
